import { Alert, Divider, Image, Stack, Title } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useSelectedAirline } from "../../hooks/useSelectedAirline";
import { useAuth } from "../../hooks/useAuth";
import { AirlineLogo } from "../AirlineLogo";

export const PerformanceReportHeader = () => {
  const i18n = useI18n();
  const { isAirlineUser } = useAuth();
  const { selectedAirline, selectedAirlineCodes: selectedCodes } = useSelectedAirline();

  const newCalculationDisclaimer = i18n.trans(t("flights_airline_portal_data_new_calculation_disclaimer"));
  const superuserWarning = i18n.trans(
    t("flights_airline_portal_superuser_perf_report_warning_banner", {
      variables: { start_bold: "", end_bold: "" },
    })
  );

  const alertBanner = (
    <Alert
      variant="warning"
      text={
        isAirlineUser ? (
          newCalculationDisclaimer
        ) : (
          <>
            {superuserWarning}
            <br />
            {newCalculationDisclaimer}
          </>
        )
      }
    />
  );

  const titleSection = (
    <Stack gap={2} mixin={{ paddingBlockEnd: isAirlineUser ? 0 : 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap={3}>
          <Title title={i18n.trans(t("flights_airline_portal_airline_view_page_title"))} variant="headline_1" />
          <Image
            asset={{
              setName: "images-genius",
              assetName: "GeniusLogo",
            }}
            height={4}
          />
        </Stack>
        {selectedAirline && selectedCodes.length <= 1 && <AirlineLogo airline={selectedAirline} />}
      </Stack>
    </Stack>
  );

  return (
    <Stack gap={8}>
      {isAirlineUser ? (
        <>
          {titleSection}
          <Divider />
          {alertBanner}
        </>
      ) : (
        <>
          {alertBanner}
          {titleSection}
        </>
      )}
    </Stack>
  );
};
